import { Breadcrumb, Button, Form, Input } from "antd";
import { Header } from "antd/es/layout/layout";
import styled from "styled-components";

// 头部容器
export const LHeader = styled(Header)`
  width: 100%;
  height: 80px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
`;

// 展开隐藏按钮组件
export const CollapsedIcon = styled.div`
  font-size: 25px;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: black;
  cursor: pointer;
`;

export const BreadcrumbCom = styled(Breadcrumb)`
  :where(.css-dev-only-do-not-override-1e3x2xa).ant-breadcrumb a,
  .ant-breadcrumb-separator {
    color: black !important;
  }
`;

export const SpanBread = styled.span`
  color: black;
`;
export const LeftBox = styled.div`
  display: flex;
  align-items: center;
`;

export const LoginOut = styled.div`
  color: black;
  padding: 0 20px;
  cursor: pointer;
`;

export const ChangePassword = styled.div`
  color: black;
  padding: 0 20px;
  cursor: pointer;
`;

export const SearchButton = styled(Button)`
  width: 70px;
  height: 32px;
  background: #ffffff;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #3775ed;
  color: #3775ed;
`;

export const ResetButton = styled(Button)`
  width: 70px;
  height: 32px;
  background: #3775ed;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  color: #ffffff;
`;

export const LoginItem = styled(Form.Item)`
  margin: 20px 0;
  text-align: center;
`;

// 密码输入框
export const PasswordInput = styled(Input.Password)`
  border: 1px solid black;
  border-radius: 20px;
`;

export const AvatarCom = styled.div`
  border-radius: 60%;
  overflow: hidden !important;

`;